/* Copyright (c) 2019 - 2022. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

export const en = {
  common: {
    back: "Back",
    confirm: "Confirm",
    log_in: "Log in",
    email: "Email",
    valid_email: "Please enter a valid email address",
    no_gmail:
      "Please enter your business email address. This form does not accept addresses from gmail.com",
    email_required: "Email is required",
    enter_email: "Enter your email",
    password: "Password",
    please_enter_password: "Please enter a password",
    accept: "ACCEPT",
    close: "Close",
    clear: "Clear",
    already_signup:
      "You have already completed the sign up process. Our team will review your application and you will receive an e-mail once your account is approved.",
    code: "Code",
    enter_code: "Enter confirmation code",
    code_required: "Confirmation code is required.",
    valid_code: "Please enter a valid confirmation code.",
    send_code: "Send Code",
    resend_code: "Resend Code",
    enter_new_password: "Enter your new password",
    valid_password:
      "The password must be at least 8 characters long, and contain lowercase, uppercase, numeric and special characters",
    confirm_password: "Confirm password",
    password_no_match: "Passwords don't match",
    new_password_for_account: "Set a new password for your account",
    set_password: "Set Password",
    ok: "OK",
    cancel: "Cancel",
    terms_title: "Terms & Conditions - Verimatrix App Shield",
    valid_work_email: "Please enter a valid work email address",
    password_required: "Password is required",
    digit_code_required: "6-digit code required",
    can_log_in: "You can now log in to your account",
    code_sent: "Verification code was sent successfully.",
    send_code_to: "Send confirmation code to {{email}}",
    already_code: "I already have a verification code",
    contact_required: "Contact information verification is required",
    privacy_notice: "Privacy Notice",
    terms_and_conditions: "Terms and Conditions",
    please_wait: "Please wait...",
    please_upgrade: "Please upgrade to access protection.",
    please_upgrade_monitor: "Please upgrade to access monitor functionality.",
    account_expired: "Account expired",
    addr_line_1: "Address (Line 1)",
    addr_line_2: "Address (Line 2)",
    company_info: "Company Info",
    unable_load: "Unable to load company info at this time.",
    failed_load: "Failed to load company info.",
    unable_save: "Unable to save company info at this time",
    company_details: "Company Details",
    company_name: "Company Name",
    sub_plan: "Subscription Plan",
    save: "Save",
    my_account_title: "My Account - Verimatrix App Shield",
    loading: "Loading...",
    saving: "Saving...",
    update_profile: "Update profile",
    update_profile_error: "Unable to update profile at this time",
    name_required: "Name is required",
    valid_name: "Allowed characters are letters, apostrophe (') and dash (-).",
    monitor: "Monitor",
    enabled: "enabled",
    disabled: "disabled",
    telephone_1: "Telephone 1",
    telephone_2: "Telephone 2",
    select_country: "Select country",
    state: "State",
    state_country: "State / County",
    country: "Country",
    zip_required: "Zip code is required",
    city_town: "City / Town",
    zip_code: "Zip code",
    zip_post: "Zip code / Postcode",
    load_user: "Load user",
    load_user_error: "Unable to load user info at this time",
    fetch_user_error: "Failed to fetch user info",
    disable_user: "Disable user",
    disable_user_error: "Unable to disable user at this time",
    enable_user: "Enable user",
    enable_user_error: "Unable to enable user at this time",
    update_permission: "Update user permission",
    update_permission_error: "Unable to update user permission",
    personal_details: "Personal Details",
    job_title: "Job title",
    role: "Role",
    select_role: "Select Role",
    profile_image: "Profile image",
    change_password: "Change Password",
    contact_information: "Contact Information",
    permissions: "Permissions",
    aiid_mgmt: "App Instance Management",
    advanced: "Advanced",
    user_is: "User is",
    access: "Access",
    signup_header:
      "Create Your Account in Minutes to Protect Your First 2 Apps",
    signup_p1: "Your free {{DEFAULT_TRIAL_DAYS_NUM}}-day trial includes:",
    signup_p2:
      "No-code app protection for up to two apps (one Android and one iOS)",
    signup_p3: "Online training with webinars, videos, and a community forum",
    signup_p4:
      "App protection that will continue to keep you safe after publishing",
    award_winning: "Award-Winning, Innovative Application Shielding",
    learn_more: "LEARN MORE",
    or: "Or",
    start_trial: "start a free trial",
    start_your_trial: "Start your {{DEFAULT_TRIAL_DAYS_NUM}}-day free trial",
    sign_up_today: "Sign up today",
    reset_password: "Reset password",
    verify_contact: "Verify contact",
    confirm_email: "Confirm email",
    title: "Verimatrix App Shield - Mobile App Shielding made easy",
    full_name: "Full name",
    one_click_away:
      "You’re one click away from enterprise-level app protection.",
    enter_full_name: "Enter full name",
    work_email: "Work email address",
    company: "Company",
    enter_company_name: "Enter company name",
    company_required: "Company name is required",
    please_select_country: "Please select a country",
    choose_password: "Choose a password",
    i_have_discount: "I have a discount code",
    discount: "Discount",
    enter_discount: "Enter discount code",
    click_to_agree:
      "Check here to indicate that you have read and agree to the",
    you_must_agree: "You must agree to the terms and conditions",
    by_submitting:
      "By submitting this form, I agree to the processing of my personal data for the purpose of responding to my request, in compliance with Verimatrix’s",
    sign_up: "SIGN UP",
    already_account: "Already have an account?",
    enter_address: "Please enter your address below",
    address: "Address",
    street_address: "Street address",
    street_address_required: "Street address is required",
    address_2: "Address line 2",
    city: "City",
    city_required: "City is required",
    create_account: "Create Account",
    page_title: "Start free trial - Verimatrix App Shield",
    missed_something: "Missed something?",
    go_back: "Go back",
    review_message:
      "Thank you! Our team will review your application and you will receive an e-mail when it is approved.",
    update_image: "Update image",
    upload_image: "Upload image",
    update_image_error: "Unable to update profile image at this time",
    upload_failed: "Upload Failed",
    server_error: "Server reported an error.",
    upload_error: "Unable to retrieve upload URL.",
    failed_image_load: "Failed to load image",
    select_different_file: "Please select a different file.",
    remove: "Remove",
    contacts: "Contacts",
    users_error: "Unable to fetch users at this time.",
    contact_data_error: "Failed to load contacts data.",
    add_user: "Add User",
    invite_error: "Unable to invite a new user at this time.",
    user_exists: "A user with this email address is already a member.",
    bad_address:
      "The provided email address is not allowed, please enter a valid work email address.",
    invite_success: `An invitation email was sent to the user.
                     Note: the new user must complete the signup within 7 days, after which the temporary credentials will expire.`,
    update_user: "Update user",
    update_user_error: "Unable to update user at this time",
    send_invite:
      "Send an invitation to a member of your organization to be added to your App Shield account.",
    name: "Name",
    users: "Users",
    no_users:
      "No other users yet. Invite other users from your organization to Verimatrix App Shield.",
    no: "No",
    app: "app",
    apps: "apps",
    date: "Date",
    upgrade: "Upgrade",
    invite_user: "Invite User",
    price_per_month: "Price per month",
    maximum_versions_protected: "Maximum versions protected",
    per_month: "per month",
    support_response: "24hr support response",
    community_forum: "Community forum",
    online_training: "Online training",
    user_limit: "User limit",
    admin_users: "Admin users",
    rest_api: "REST API for CI/CD integration",
    upgrade_title: "Upgrade - Verimatrix App Shield",
    unlimited: "Unlimited",
    per_app: "per app",
  },
  upgrade: {
    upgrade: "Upgrade subscription",
    auth_error:
      "Unable to upgrade the subscription, failed to authenticate the payment transaction.",
    upgrade_error:
      "Unable to upgrade the subscription. Please try again. If the problem persists, please contact support.",
    support_upgrade:
      "To upgrade the subscription plan for this account, please contact customer support.",
    to_upgrade: "To upgrade your current plan to",
    contact_support: "please contact customer support.",
    upgrade_your: "Upgrade your plan to",
    for: "for",
    per_month: "per month.",
    contact_admin: "Contact your company admin to upgrade your subscription.",
    contact_admin_2: "Contact your company admin to upgrade this account.",
    contact_admin_3:
      "Please contact your company admin to upgrade the subscription for account.",
    enhanced_message:
      "For specific requirements, please contact your account manager.",
    this_plan: "This account plan is",
    flexible: "Flexible Pricing to Meet Every Need",
    expired: "Your subscription expired",
    choose_option: "Please choose one of the upgrade options below.",
    plan_replaced: "Your plan has been replaced",
    plan_replaced_message:
      "You can continue using your current plan, or upgrade to one of the plans below",
  },
  changeEmail: {
    change: "Change Email",
    change_error: "Unable to change email at this time.",
    change_ok:
      "Email address was changed successfully, a confirmation code was sent to the new email. You should now log in with the new email, and validate it.",
    current: "Current email",
    new: "New Email",
    enter_new: "Enter new email",
    must_be_different: "The new email must be different than the current one",
    confirm: "Confirm email",
    confirm_new: "Confirm new email",
    no_match: "Emails don't match",
  },
  changePassword: {
    change_password: "Change Password",
    change_error: "Unable to change password at this time:",
    current: "Current password",
    enter_current: "Enter current password",
    new: "New password",
    enter_new: "Enter new password",
    must_be_different:
      "The new password must be different than the current one",
    confirm: "Confirm password",
    confirm_new: "Confirm new password",
    not_match: "Passwords don't match",
  },
  billing: {
    invoices: "Invoices",
    invoice_error: "Unable to load invoices at this time.",
    set_vat_error: "Unable to update VAT number at this time.",
    vat_value_error:
      "Invalid VAT number specified. Check that the VAT number and type are correct.",
    vat_exists_error: "The specified VAT number and type are already set.",
    update_vat: "Update VAT",
    set_vat_ok: "VAT details updated successfully.",
    payment_auth_error: "Failed to authenticate the payment method.",
    update_pay_method: "Update Payment Method",
    update_pay_ok: "The payment method was updated successfully.",
    update_pay_error:
      "Unable to update the payment method. Please try again. If the problem persists, please contact support.",
    no_pay_info: "Payment method info unavailable",
    pay_method_reg: "Payment method not registered",
    view: "View",
    billing_period: "Billing Period",
    current_period: "Current billing period",
    protected_successfully: "protected successfully",
    no_apps_protected: "No apps protected",
    billing_ends: "Billing period ends at",
    subscription_details: "Subscription Details",
    current_sub: "Your current subscription",
    payment_method: "Payment method",
    subscription_active: "Subscription active until",
    plan: "Plan",
    status: "Status",
    total: "Total",
    vat: "VAT",
    vat_number: "VAT Number",
    vat_number_type: "VAT Number Type",
    cancellation: "Cancellation",
    cancel_subscription: "Cancel subscription",
    resume_subscription: "Resume Subscription",
    contact_resume: "Please contact support to resume this subscription.",
    name_on_card: "Name on Card",
    card_number: "Card Number",
    card_expiration: "Card Expiration",
    pay_process_error:
      "Failed to load payment processing, please refresh the page and retry.",
    process_error:
      "Failed to process card details, please refresh the page and retry.",
    failed_create_method: "Failed to create payment method.",
  },
  developer: {
    list_keys: "List API Keys",
    api_keys: "API Keys",
    fetch_error: "Unable to fetch API keys at this time",
    create_api_key: "Create API Key",
    create_error: "Unable to create an API key at this time.",
    create_ok: "A new API key was created successfully.",
    free_trial:
      "Note: once your free trial has finished, API integration for Protection will only be available if you upgrade to the Pro plan.",
    delete: "Remove Key",
    delete_key: "Remove API Key",
    delete_confirm: "Are you sure you want to remove this API key?",
    delete_error: "Unable to delete the API key at this time.",
    delete_ok: "API key was removed successfully.",
    show: "Show API Key",
    show_error: "Unable to show key info at this time",
    no_keys: "No keys yet, click Add Key to add a new API key.",
    Created: "Created",
    id: "API Key ID",
    scope: "Scope",
    add_api_key: "Add API Key",
    add_key: "Add Key",
    select_scope: "Select API Key Scopes",
    select_one_scope: "Please select at least one scope for this key",
    create_key: "Create Key",
    generate_token: "Generate token",
    generate_token_error: "Unable to generate the token at this time.",
    key_details: "API Key Details",
    token_expires: "Token expires:",
  },
  signIn: {
    log_in: "LOG IN",
    forgot_password: "Forgot password?",
    google_rc1: "This site is protected by reCAPTCHA and the Google",
    google_rc3: "and",
    google_rc4: "Terms of Service",
    google_rc5: "apply.",
    enter_password: "Enter your password",
    signed_out: "You've been signed out, please sign back in.",
    account_pending:
      "Your account is pending approval from company admin / support (you'll receive an email once your account is approved)",
    no_login: "User login is not enabled",
    incorrect_user_pass: "Incorrect username or password.",
    must_accept: "The End User License Agreement must be accepted",
  },
  forgotPassword: {
    enter_email_to_reset:
      "Enter your email address below to reset your password.",
    reset_password: "RESET PASSWORD",
    back: "Back to Login",
    set_new_password: "Set your new password below.",
    new_password_required: "New password is required.",
    password_confirm_required: "Password confirmation is required.",
    set_new_password_title: "SET NEW PASSWORD",
    invalid_email:
      "Invalid email address, make sure that the email address is correct.",
    reset_success:
      "Password was reset successfully. You can now log in with your new password.",
  },
  confirmSignup: {
    received_email:
      "You should have received an email with your Confirmation Code. If not, you can use the link above to request another one. Please note, sometimes the email ends up in the Junk mail folder.",
    email_confirmed:
      "Email confirmed. You'll receive an email once your account is approved.",
    confirm: "CONFIRM",
  },
  footer: {
    follow_us: "Follow us",
    user: "User",
    sign_up: "Sign up",
    about_us: "About us",
    app_shielding: "Application Shielding",
    plans: "Plans",
    vmx_hq: "Verimatrix Corporate HQ",
    cookie_settings: "Cookie Settings",
  },
  home: {
    learn_more: "Learn more",
    protect_first: "Protect Your First App",
    all_in_use: "All{{slotsInUsePlatform}}app slots are in use.",
    for_more_apps: "for more apps",
    upload_new_app: "Upload a New App",
    my_apps: "My Applications",
    fetching_apps: "Fetching apps...",
    no_builds: "No protected builds",
    trial_has: "Your Free Trial has",
    day: "day",
    days: "days",
    to_go: "to go",
    you_are_using:
      "You are using {{totalProtections}} of your {{maxVers}} available builds",
    protected_in_last: "protected in the\ncurrent billing period",
    see_new_plans: "See our new plans",
    protectStarter: "Upgrade your subscription from Starter to Standard for",
    protectStandard: "Upgrade your subscription from Standard to Pro for",
    protectProfessional: "Your subscription is Pro, giving you access to",
    enhancedSupport: "Your subscription is Enterprise - Enhanced Support",
    monitoringSecurityOperationsCenter:
      "Your subscription is Monitoring - Security Operations Center",
    monitoringAppInstanceLookup:
      "Your subscription is Monitoring - App Instance Lookup",
    monitoringUltimate: "Your subscription is Monitoring - Ultimate",
    sub_to_starter: "Subscribe to our Starter plan for",
    protection_control: "Protection\nControl",
    ci_cd: "CI/CD\nIntegration",
    hour_sup: "24Hour\nSupport ",
    unlimited_apps: "Unlimited\nApps",
    unlimited_prot: "Unlimited\nProtections",
    unlimited_access: "Unlimited\nAccess",
    plat_apps: "1 Android\nor iOS App",
    forum: "Community\nForum",
    upgrade: "UPGRADE",
    upload_app: "Upload App",
    upload_your_app: "Upload Your App",
    home_title: "Home - Verimatrix App Shield",
    app_shield_sub: "App Shield Subscription",
    billing_failed:
      "Billing for your subscription failed. Your registered payment method was declined or authentication is required. Please update your payment method or authenticate.",
  },
};
